import styled from 'styled-components';

// const cardTypeColor = {
// 	draft: 'red',
// 	pinned: '#fff'
// };

export const UiCardType = styled.div`
display: flex;
align-items: center;
justify-content: center;
margin-right: 1rem;
padding: 4px 24px;
color: #4c99a5;
background: #eef5f6;
border: 1px solid #eef5f6;
border-radius: 20px;
box-sizing: border-box;
line-height: 140.62%;
letter-spacing: 0.05em;
`;

export const UiAnnouncementCardHead = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
`;

export const UiAnnouncementCardRead = styled.div`
	width: 100%;
	line-height: 24px;
	font-size: 16px;
	font-weight: 400;
	color: #454b5c;

`;
// export const UiTeacherInfo = styled.div`

// `;

export const UiUserName = styled.div`
	font-size: 1.2rem;
	font-weight: bold;
`;

export const UiCreateDateBox = styled.div`
margin-right: 1rem;
min-width: 100px;
height: min-content;
text-align: center;
color: #242c3f;
background: #f2f4f8;
`;
export const UiCreateWeek = styled.div`
	padding: 0.5rem 0;
	font-size: 16px;
	font-weight: 400;
	color: #fff;
	background-color: #121232;
	line-height: 24px;
`;

export const UiCreateDateAll = styled.div`
	margin: 1rem 0;
	font-size: 1.2rem;
`;

export const UiCreateDate = styled.div`
	line-height: 24px;
	font-size: 16px;
	font-weight: 400;
`;
export const UiContentBox = styled.div`
color: #8b90a0;
`;

export const UiContentTitle = styled.div`
	display: flex;
	align-items: center;
	padding-bottom: 0.25rem;
	font-size: 20px;
	font-weight: 400;
	color: #242c3f;

	> svg {
		margin-left: 1.5rem;
	}
`;

export const UiContent = styled.div`
	padding: 0.25rem 0;
	line-height: 24px;
	font-size: 14px;
	font-weight: 400;
	color: #242c3f;

	> a {
		text-decoration: none;
		color: #4c99a5;

		&:hover {
			text-decoration: underline;
		}

		&:visited {
			color: #36757d;
		}
	}
`;

export const UiCardFooter = styled.div`
padding: 0.5rem 0.75rem;
`;


export const LabelGroup = styled.div`
	display: flex;
	margin-right: 1rem;
	min-width: ${({ userType }) => userType === 'teacher' ? '35%' : 'unset'};
`;

export const Label = styled.div`
	margin-right: 0.5rem;
	font-weight: bold;
`;

export const LabelValue = styled.div`
`;
export const UiChangeButtonBox = styled.div`
	button {
		margin: 8px 8px 8px 0;
	}
`;
export const UiStudentHomeworkForm = styled.div`
	form {
		padding: 0;

		& > div > div > button {
			margin: 8px 8px 8px 0;
		}
	}
`;

export const UiCardHeader = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	margin: 0 0.75rem;
	padding: 0.5rem 0;
	border-bottom: 1px solid #e4e7ec;
`;

export const UiCardHeaderRow = styled.div`
	display: flex;
`;

export const UiCardContent = styled.div`
	font-size: 1rem;
	padding: 0.5rem 0.75rem;
	word-break: break-all;
`;
export const UiCardFooterRow = styled.div`
	display: flex;
	align-items: flex-start;
	margin-bottom: 0.5rem;
`;
export const UiCardFooterBox = styled.div`
	position: relative;
	padding: 0.5rem;
	width: 50%;
	min-width: 300px;
	color: #454b5c;
	background-color: #fff;
	border: 1px solid #f2f4f8;
	font-size: 1rem;

	&:first-child {
		margin-right: 1rem;
	}
`;
export const UiCardFooterBoxTitle = styled.div`
	line-height: 24px;
	font-size: 16px;
	font-weight: 400;
	color: #ec7963;
`;
export const UiCardFooterFileBox = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 0.5rem;
	width: 50%;
	min-width: 300px;
	color: #454b5c;
	background-color: #fafafc;
	border: 1px solid #fff;
`;

export const UiCardFooterFileBoxLabel = styled.div`
	display: flex;
	font-size: 16px;
`;

export const UiCardFooterFileBoxIcon = styled.div`
	display: flex;
	width: 1.5rem;
	height: 1.5rem;

	& > svg {
		width: 100%;
		height: 100%;
	}
`;


export const UiCheckBlock = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 2;
`;

export const UiRolesGroup = styled.div`
	display: flex;
	align-items: center;
	min-width: 54px;

	> .tag {
		padding: 2px 8px;
		color: #fff;
		background-color: #121232;
		border-radius: 4px;

		+ .tag {
			margin-left: 8px;
		}
	}
`;
